/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { QuantityMapping } from '../units/unitTypes';
import { CalculatorResult, ParameterName, NumericParameterValues, StringParameterValues, getValidityState } from './calculatorTypes';

const paramConfig = require('./parameterConfig.json');
const unitPresets = require('../units/unitPresets.json');

////////////////////////////////////////////////////
// PARAMETERS
////////////////////////////////////////////////////

export const getDefaultParameters = () => {
  const defaults = new CalculatorResult();
  defaults.validityState = getValidityState();
  paramConfig.cards.forEach((card: any) => {
    card.rows.forEach((row: any) => {
      defaults.parameters[paramNameForRow(row)] = parseModifier(row.modifier) as any;
    });
  });
  return defaults;
};

export const paramNameForRow = (row: any) => row.labelKey.split('.')[1] as ParameterName;

const parseModifier = (modifierConfig: any) => {
  const sanitized = modifierConfig.default ?? 0;
  switch (modifierConfig.type) {
    case 'numeric':
      return new NumericParameterValues(sanitized);
    case 'select':
      return new StringParameterValues(modifierConfig.options[sanitized]);
  }
  throw new TypeError('Invalid config: cannot parse type ' + modifierConfig.type);
};

export const isAdvanced = (parameter: ParameterName) => {
  let match: any = undefined;
  paramConfig.cards.some((card: any) => {
    const row = (card.rows as any[]).find((r) => paramNameForRow(r) === parameter);
    if (row) {
      match = row;
      return true;
    }
    return false;
  });
  if (match) {
    return match.isAdvanced;
  }
  throw new TypeError('isAdvanced(): Invalid config: parameter not found: ' + parameter);
};

////////////////////////////////////////////////////
// UNITS
////////////////////////////////////////////////////

export const getQuantities = () => {
  let config: QuantityMapping[] = [];
  paramConfig.cards.forEach((card: any) => {
    config = config.concat(
      card.rows.map((row: any) => ({
        parameter: paramNameForRow(row),
        quantity: row.quantity,
      }))
    );
  });
  return config;
};

export const getUnitPresets = () => {
  return unitPresets.presets.map((preset: any) => ({
    mode: preset.mode,
    selections: Object.entries(preset.selections).map((sel) => {
      const [key, value] = sel;
      return { parameter: key, unitIndex: value };
    }),
  }));
};
